import { Save } from '@mui/icons-material';
import { Button, ButtonProps } from '@mui/material';

import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

import SubmittingLoader from '../Util/SubmittingLoader';

interface SaveButtonProps extends ButtonProps {
  isSubmitting?: boolean;
  isValid?: boolean;
}

export const SaveButton = ({ isValid, isSubmitting, ...props }: SaveButtonProps) => {
  const { t } = useTranslation();
  return (
    <span
      style={{
        position: 'relative'
      }}
    >
      <Button
        {...props}
        variant="contained"
        className="button--create"
        style={props.style ? props.style : { color: 'white' }}
        onClick={props.onClick}
        type="submit"
        startIcon={<Save />}
        disabled={isSubmitting || isValid === false}
      >
        {props.children || t(translations.common.save())}
      </Button>
      {isSubmitting && <SubmittingLoader />}
    </span>
  );
};
